export const SUPPORT_EMAIL = 'mike@mccarthysearch.com';

export const JOB_DETAILS_LOADER_TEXTS = [
  'Confirming this job is active and ready for your application',
  'Ensuring you have the latest details to make an informed decision',
  'If this role is no longer available, we’ll show you options that fit your search',
];

export const PROFILE_LOADER_TEXTS = [
  'Building your professional profile to showcase your potential',
  'Curating key details to showcase your expertise',
];

export const DEFAULT_LOADER_TEXTS = ['Gathering insights', 'Loading resources'];

export const STUB_DEFAULT_TEXTS = {
  mainText: 'Nothing found',
  subText:
    'Sorry, but nothing matched your search terms. Please try again with some different keywords',
};
